import styled from 'styled-components/macro';
// eslint-disable-next-line
import css from '@styled-system/css';
import { variant } from 'styled-system';

import { rem } from '@blueprint/ui';
import { Text } from '../Typography';

/**
 * inlineVariant
 */
const inlineVariant = variant({
  prop: 'show',
  variants: {
    multiline: css({
      display: 'flex',
      flexDirection: 'column',
      '.Notification-title': {
        paddingBottom: rem(13),
      },
      '.Notification-title ~ :not(:last-child)': {
        paddingBottom: rem(8),
      },
    }),
  },
});

/**
 * ContentWrapper
 * for width: 100%, https://stackoverflow.com/questions/35111090/text-in-a-flex-container-doesnt-wrap-in-ie11
 */
const ContentWrapper = styled(Text)`
  flex: 1 1 auto;
  color: ${(props) => (props.mode === 'dark' ? '#ffffff' : 'inherit')};
  align-self: flex-end;
  -ms-overflow: hidden;
  ${inlineVariant}
  margin-left: ${rem(8)};
`;

ContentWrapper.displayName = 'NotificationContentWrapper';

export default ContentWrapper;
